import React, { createContext, useContext, useState } from "react";

const BarcodeContext = createContext();

export const BarcodeProvider = ({ children }) => {
  const [barcodeItems, setBarcodeItems] = useState([]);

  return (
    <BarcodeContext.Provider value={{ barcodeItems, setBarcodeItems }}>
      {children}
    </BarcodeContext.Provider>
  );
};

export const useBarcode = () => useContext(BarcodeContext);
